import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '../../../../types/product.js';
import '@swc/helpers';
import { useSolutionsEcommContext } from '../context/SolutionsEcommContext.js';

const useGetSolutionsLoyaltyPoints = ()=>{
    const { displayPrice: { loyaltyPoints  } ,  } = useProductData();
    const { state  } = useSolutionsEcommContext();
    if (!loyaltyPoints) {
        return undefined;
    }
    return loyaltyPoints * state.configurations.quantity;
};

export { useGetSolutionsLoyaltyPoints };
//# sourceMappingURL=use-get-solutions-loyalty-points.js.map
